import { GetTokenSilentlyVerboseResponse } from '@auth0/auth0-spa-js'
import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class GetAccessToken {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<GetTokenSilentlyVerboseResponse> {
    return this.authenticationRepository.getAccessToken()
  }
}
